
<div [hidden]="!profil.mandats || profil.mandats.length === 0" class="row">
    <div class="col">
        <div class="container-mat-table container-mat-table-sticky">
            <table class="mat-table-data-list mat-table-dense" mat-table matSort [dataSource]="mandats" (matSortChange)="changeSort($event)">

                <ng-container matColumnDef="commission.commissionType.label">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'general.type' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.commission.commissionType.label}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="commission.label">
                    <th mat-header-cell  *matHeaderCellDef mat-sort-header>{{'general.sousType' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.commission.label }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="mandatType.label">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'general.poste' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ roleLabel(element.mandatType.label)}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="dateDebut">
                    <th mat-header-cell  *matHeaderCellDef mat-sort-header>{{'general.debut' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.dateDebut | date : dateShort }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="dateFin">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'general.fin' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.dateFin | date : dateShort }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="statut">
                    <th mat-header-cell  *matHeaderCellDef>{{'general.statut' |translate}}</th>
                    <td mat-cell *matCellDef="let element">
                        {{ getStatus(element) }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="MATERIAL_COLUMNS; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: MATERIAL_COLUMNS;"></tr>

            </table>
        </div>
    </div>
</div>

<div [hidden]="profil.mandats && profil.mandats.length > 0">
    <div class="row">
        <div class="col">
            {{'front.profil.profilCompletFinal.infoExpert.avezEncoreMandatVousPourrez' | translate}}
        </div>
    </div>
</div>
